var map = {
	"./config.dev.json": 429,
	"./config.prod.json": 430
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/config\..*\.json$
// module id = 428
// module chunks = 1